import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ButtonCustom from "../../../../../../../../../../../../../../Components/ButtonCustom"
import { SidebarAlterations, SidebarContainerFullscreen, SidebarContent, SidebarFooter, SidebarHeader, SidebarTopBar } from "../../styled"
import { faArrowLeft, faFloppyDisk } from "@fortawesome/free-solid-svg-icons"
import { calculoAreaCoord } from "../../../../../../../../../../../../../../services/Afins"
import { Switcher } from "../../../../../../../../../../../../../../Components/CustomUi/Switcher"
import { ControleLateralModal } from "../controleLateralModal"
import { GeoPointFeature } from "../.."
import { PropsAnalisesCadastradas } from "../../../../../../../../../.."
import { LabAnaliseItens } from "../../../../../../../../../../../../../../services/LabAnalise"

interface Props {
    toggleFullscreen: Function
    inserirPontos: boolean
    moverPontos: boolean
    talhaoPath: any
    pontos: GeoPointFeature[]
    setInserirPontos: React.Dispatch<React.SetStateAction<boolean>>
    setMoverPontos: React.Dispatch<React.SetStateAction<boolean>>
    tipo_analise_selecionada: string
    setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>
    tipo_analise_selecionada_id: number
    setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>
    pontos_selecionados: GeoPointFeature[]
    setPontos_selecionados: React.Dispatch<React.SetStateAction<GeoPointFeature[]>>
    selecionarTodos: boolean
    setSelecionarTodos: React.Dispatch<React.SetStateAction<boolean>>
    pontos_selecionados_adicionados: PropsAnalisesCadastradas[]
    setPontos_selecionados_adicionados: React.Dispatch<
        React.SetStateAction<PropsAnalisesCadastradas[]>
    >
    cor: string
    setCor: React.Dispatch<React.SetStateAction<string>>
    fake_loading: boolean
    grupoAnalises: LabAnaliseItens[]
    grupoAnalisesTratado: any[]
    pontosTotalMalha: number
    salvarPontosSelecionados: Function
    adicionarPontosSelecionados: Function
    selecionarTodosPontos: Function
    deletarPontosSelecionados: Function
}

export const CardFullscreen = ({
    toggleFullscreen,
    inserirPontos,
    talhaoPath,
    grupoAnalises,
    grupoAnalisesTratado,
    pontosTotalMalha,
    moverPontos,
    pontos,
    cor,
    setCor,
    fake_loading,
    setInserirPontos,
    setMoverPontos,
    tipo_analise_selecionada,
    setTipo_analise_selecionada,
    setTipo_analise_selecionada_id,
    pontos_selecionados,
    selecionarTodos,
    pontos_selecionados_adicionados,
    salvarPontosSelecionados,
    adicionarPontosSelecionados,
    selecionarTodosPontos,
    deletarPontosSelecionados
}: Props) => {
    return (
        <SidebarContainerFullscreen>
            <SidebarTopBar>
                <ButtonCustom
                    type="tertiary"
                    danger
                    onClick={() => toggleFullscreen()}
                    icon={<FontAwesomeIcon icon={faArrowLeft} />}
                >
                    Voltar
                </ButtonCustom>
            </SidebarTopBar>

            {/* Header: Informações */}
            <SidebarHeader>
                <div className='info__item'>
                    <label>Área</label>
                    <p>{calculoAreaCoord([talhaoPath])} ha</p>
                </div>
                <div className='info__item'>
                    <label>Grid amostral</label>
                    <p>
                        {pontos.length > 0
                            ? (calculoAreaCoord([talhaoPath]) / pontos.length).toFixed(2)
                            : 0}{' '}
                        ha/ponto
                    </p>
                </div>
                <div className='info__item'>
                    <label>Pontos</label>
                    <p>{pontos.length}</p>
                </div>
            </SidebarHeader>

            {/* Alterações */}
            <SidebarAlterations>
                <label>Habilitar alterações</label>
                <Switcher
                    label='Inserir pontos'
                    isChecked={inserirPontos}
                    trigger={(checked) => {
                        setInserirPontos(checked)
                        if (checked) setMoverPontos(false)
                    }}
                />
                <Switcher
                    label='Mover pontos'
                    isChecked={moverPontos}
                    trigger={(checked) => {
                        setMoverPontos(checked)
                        if (checked) setInserirPontos(false)
                    }}
                />
            </SidebarAlterations>

            {/* Conteúdo: Controle Lateral */}
            <SidebarContent>
                <ControleLateralModal
                    inserirPontos={inserirPontos}
                    setInserirPontos={setInserirPontos}
                    moverPontos={moverPontos}
                    setMoverPontos={setMoverPontos}
                    tipo_analise_selecionada={tipo_analise_selecionada}
                    setTipo_analise_selecionada={setTipo_analise_selecionada}
                    cor_selecionada={cor}
                    setCor_selecionada={setCor}
                    setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
                    selecionarTodos={selecionarTodos}
                    grupoAnalises={grupoAnalises}
                    talhao_area={String(calculoAreaCoord([talhaoPath]))}
                    pontos_totais={pontosTotalMalha}
                    pontos={pontos_selecionados}
                    pontos_selecionados_adicionados={pontos_selecionados_adicionados}
                    fake_loading={fake_loading}
                    grupoAnalisesTratado={grupoAnalisesTratado}
                    adicionarPontosSelecionados={adicionarPontosSelecionados}
                    selecionarTodosPontos={selecionarTodosPontos}
                    deletarPontosSelecionados={deletarPontosSelecionados}
                    isFullscreen // Prop para ajustar layout interno se necessário
                />
            </SidebarContent>

            {/* Footer: Botões */}
            <SidebarFooter>
                <div>
                    <ButtonCustom
                        onClick={() => {
                            salvarPontosSelecionados()
                            toggleFullscreen()
                        }}
                        icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                        style={{ flex: 1 }}
                    >
                        Salvar
                    </ButtonCustom>
                </div>
            </SidebarFooter>
        </SidebarContainerFullscreen>
    )
}